import { render, staticRenderFns } from "./Portfolios.vue?vue&type=template&id=4881015e&"
import script from "./Portfolios.vue?vue&type=script&lang=js&"
export * from "./Portfolios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports